import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { SoggettoDialogComponent } from 'src/app/shared/components/soggetto-dialog/soggetto-dialog.component';
import { Indirizzo } from 'src/app/shared/models/indirizzo.model';

@Component({
  selector: 'app-gestione-indirizzi',
  templateUrl: './gestione-indirizzi.component.html',
  styleUrls: ['./gestione-indirizzi.component.scss']
})
export class GestioneIndirizziComponent implements OnInit {
  public indirizziConfermati$: Observable<Indirizzo[]> = of([]);
  @ViewChild(SoggettoDialogComponent) private soggettoDialog: SoggettoDialogComponent;

  constructor(public anagraficheService: AnagraficheService) { }

  ngOnInit(): void {
    this.indirizziConfermati$ = this.anagraficheService.indirizzi.getAllConfermati();
  }

  filterConfermati(indirizzi: Indirizzo[]): Indirizzo[] {
    return indirizzi.filter(m => m.isConfirmed);
  }

  openSoggettoDialog(): void {
    this.soggettoDialog?.open();
  }

  printIndirizzi(indirizzi: Indirizzo[]): void {
    // creazione nuova pagina di stampa
    const mywindow = window.open('');
    if ( mywindow) {
      // scrittura codice html per pagina da stampare
      mywindow.document.write(`<html><head><title>${document.title}</title>`,
        `<style>`,
        `table {font-family: arial, sans-serif; border-collapse: collapse; width: 100%;}`,
        `td, th {border: 1px solid #dddddd; text-align: left; padding: 8px;}`,
        `tr:nth-child(even) {background-color: #eeeeee; -webkit-print-color-adjust: exact;}`,
        `</style>`,
        `</head><body>`,
        `<table>`,
        `<tr><th>Indirizzo</th></tr>`);
      indirizzi.forEach((i: Indirizzo) => {
        mywindow.document.write(`<tr><td>${i.nomeIndirizzo}</td></tr>`);
      });
      mywindow.document.write(`</table></body></html>`);
      // richiesti per IE10
      mywindow.document.close();
      mywindow.focus();
      // parte la stampa e chiusura della pagina
      // mywindow.print();
      // mywindow.close();
    }
  }
}
